/**
 * Static files the app fetches through `HttpClient` (translation bundles, SVG
 * icon sprites, images, fonts) rather than API calls.
 *
 * Mirrors the skip list nera-common's `neraAuthInterceptor` already applies,
 * so every interceptor that treats "is this an API call?" the same way reads
 * one list. Relative and absolute URLs both match, and a query string or hash
 * is ignored.
 */
export const STATIC_ASSET_URL_PATTERNS: ReadonlyArray<RegExp> = [
    /(^|\/)i18n\/.+\.json$/i,
    /(^|\/)icons\/.*\.svg$/i,
    /(^|\/)images\/.*\.(png|jpg|jpeg|gif|webp|svg)$/i,
    /(^|\/)fonts\/.*\.(ttf|woff|woff2|eot|otf)$/i,
];

/** True when `url` points at a static asset, not an API endpoint. */
export function isStaticAssetUrl(url: string | null | undefined): boolean {
    if (!url) {
        return false;
    }
    const path = url.split(/[?#]/, 1)[0];
    return STATIC_ASSET_URL_PATTERNS.some((pattern) => pattern.test(path));
}
